import { formatPrice } from 'utils/helpers';
import { ListCard, ListCardProps } from 'components/list-card';
import { EventTypeTitle, EventLocationTypeTitle } from 'types';

import { LocationListCardProps } from './types';

export const LocationListCard = ({
  titles,
  location,
  template,
  extendedValues,
  isHideForSalesAndManager,
}: LocationListCardProps) => {
  let values: ListCardProps['values'] = [
    location.number,
    location?.length && location?.width
      ? `${location.length}x${location.width}ft`
      : '',
    EventLocationTypeTitle[location.locationType],
    EventTypeTitle[location.eventType],
  ];

  if (!isHideForSalesAndManager) {
    values.splice(1, 0, location?.income ? formatPrice(location.income) : '');
  }

  if (extendedValues) {
    values = [...extendedValues, ...values];
  }

  return <ListCard values={values} headers={titles} template={template} />;
};
